// @flow
import { ApolloProvider } from '@apollo/react-hooks';
import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import React, { Component } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import FlagProvider from './contexts/flagContext';
import Expired from './pages/Expired';
import Home from './pages/Home';
import Theme, { tokens } from './providers/Theme';
import { getBaseUrl } from './utils/getBaseUrl';

const { localStorage, location } = window; // eslint-disable-line no-undef

const AuthLink = (operation, next) => {
    const token = localStorage.getItem('token') || '';

    operation.setContext((context) => ({
        ...context,
        headers: {
            ...context.headers,
            Authorization: `JWT ${token}`,
        },
    }));

    return next(operation);
};

class App extends Component<any, any> {
    client: ApolloClient;

    state = {
        appContext: {
            baseInstanceUrl: '',
        },
    };

    initAppContext() {
        getBaseUrl().then((url) => {
            this.setState({ appContext: { baseInstanceUrl: url } });
        });
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        const { protocol, host } = location;

        try {
            const [, JWT] = (location.search || 'jwt=').match(/jwt=((?!&).)*/gi)[0].split('=');
            localStorage.setItem('token', JWT);
            const httpLink = ApolloLink.from([AuthLink, new HttpLink({ uri: `${protocol}//${host}/api/graphql` })]);
            this.client = new ApolloClient({
                link: httpLink,
                cache: new InMemoryCache().restore({}),
            });
            this.initAppContext();
        } catch (e) {
            console.log(e); // eslint-disable-line no-console
        }
    }

    render() {
        return (
            <div>
                <Theme.Provider value={tokens}>
                    <FlagProvider>
                        <ApolloProvider client={this.client}>
                            <div className="App">
                                <BrowserRouter>
                                    <Routes>
                                        <Route path="/app" element={<Home />} />
                                        <Route path="/app/expired" element={<Expired />} />
                                    </Routes>
                                </BrowserRouter>
                            </div>
                        </ApolloProvider>
                    </FlagProvider>
                </Theme.Provider>
            </div>
        );
    }
}

export default App;
